import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Input from '@/components/basicComponents/input';
import { SORT_ORDER } from '@/components/table/types';
import { useMutation, useQuery } from '@apollo/client';
import { useState } from 'react';
import { COPY_DUE_DILIGENCE_FUNNEL_MUTATION, DUE_DILIGENCE_FUNNEL_LIST_SETTINGS_QUERY, GET_FUNNEL_QUERY } from '../queries';
import { IFunnelDataWithStatuses } from '../types';
import { saveOnEnter } from '../utils';

interface DuplicateFunnelProps {
  onClose: () => void;
  isOpen: boolean;
  currentFunnel: IFunnelDataWithStatuses | null;
}

const DuplicateFunnel = ({ onClose, isOpen, currentFunnel }: DuplicateFunnelProps) => {
  if (!currentFunnel) return <></>;
  const [value, setValue] = useState('');

  const { data } = useQuery(GET_FUNNEL_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      id: currentFunnel.id
    },
    skip: !currentFunnel.id
  });

  const [copyFunnel] = useMutation(COPY_DUE_DILIGENCE_FUNNEL_MUTATION, {
    refetchQueries: () => [
      {
        query: DUE_DILIGENCE_FUNNEL_LIST_SETTINGS_QUERY,
        variables: {
          data: {
            statusFilter: ['PUBLISHED', 'DRAFT_WITHOUT_PUBLISHED'],
            sortDirection: SORT_ORDER.ASC,
            sortBy: 'ORDER'
          },
          archivedFunnelData: {
            sortDirection: SORT_ORDER.ASC,
            sortBy: 'ORDER'
          }
        }
      }
    ]
  });

  const saveValue = () => {
    if (data) {
      const { getDueDiligenceFunnel } = data;

      copyFunnel({
        variables: {
          data: {
            id: getDueDiligenceFunnel.id,
            newFunnelName: value
          }
        }
      });

      onClose();
    }
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Duplicate Funnel"
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value || !data
      }}
    >
      <Input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        label="Name"
        type="text"
        placeholder="Give this Funnel a unique name"
        size="lg"
        onKeyUp={(event) => saveOnEnter(event, saveValue, !value)}
        isRequiredField
        autoFocus
      />
    </ModalWrappedContent>
  );
};

export default DuplicateFunnel;
